<template>
    <div class='ImageCarousel col-12' :index='uaIdx'>
        <div class='row'>
            <div class='currentImage col-12'>
                <img :src="currentImage" alt="">
                <div class="actions">
                </div>
            </div>
        </div>
        <div class='row d-flex align-items-center'>
            <span @click="prevImage" class="arrow prev col-1">
                    &#10094;
            </span>
            <div class='slider col-10  d-flex align-items-center'>
                <transition-group name='fade' tag='div' class='row d-flex align-items-center'>
                    <div 
                        v-for="(image, index) in imageArray"
                        :key="image.id"
                        :class="['thumbnail-image col-4', (activeImage == image.id) ? 'active' : '']"
                        @click="activateImage(image.id)"
                        >
                        <img :src="image.thumb">
                    </div>
                </transition-group>
            </div>
             <span @click="nextImage" class="arrow next col - 1">
                        &#10095;
            </span>
        </div>
        <div class='ImageUpload row'>
            <div class='imageUploadForm uploadUi col-12'>
                <label for="file-upload" class="custom-file-upload">
                    Select Image
                </label>
                <input id="file-upload" type='file' accept="image/*" class='form-control-file' @change='Images_onFileChanged'/>
            </div>
        </div>
  </div>
</template>

<script>
import ImageUpload from '../../core/form/ImageUpload.vue';
export default {
    name: 'ImageCarousel',
    props:['images', 'store', 'name'],
    components:{
        ImageUpload
    },
    data() {
        return {
        
        startImage: 0,
        imageHeight: 0,
        uaIdx: 0
        }
    },
    computed: {
        imageProxy(){
            return this.source
        },
        activeImage:{
            get(){ return this.$store.getters['ItemInfo/currentImage'] },
            set(value) { return this.$store.dispatch('ItemInfo/set', {field: 'currentImage', value}) },
        },
        currentImage() {
            try{
                let current = this.activeImage ? this.imageArray.findIndex(image => image.id === this.activeImage) : 0;
                console.log('getting current image: '+ this.imageArray);
                return current == -1 ? this.imageArray[0].large : this.imageArray[current].large;
            } catch(e) {
                console.log('error: '+ e)
            }
        },
        dimensions(){
            return{
                width: this.currentImage.width,
                height: this.currentImage.height
            }
        },
        source:{
            get(){
                return this.$store.getters[this.$props.store + '/' + this.$props.name];
            },
            set (value) { 
                return this.$store.dispatch(this.$props.store + '/set', {field: this.$props.name, value}) 
            },
        },
        updateProxy(){
            let newProxy = [];
            for(let i = this.startImage; i < this.imageProxy.length; i++){
                newProxy.push(this.imageProxy[i]);
            }
            return newProxy
        },
        proxyOffset(){
            return this.imageProxy.length - this.updateProxy.length;
        },
        offSetArray(){
            let myArray = [];
            for( let j = 0; j < this.proxyOffset; j++){
                myArray.push(this.imageProxy[j]);
            }
            return myArray
        },
        imageArray(){
            let myNewArray = [];
            for(let i = 0; i < this.updateProxy.length; i++){
                myNewArray.push(this.updateProxy[i]);
            }
            for(let j = 0; j < this.offSetArray.length; j++){
                myNewArray.push(this.offSetArray[j]);
            }
            return myNewArray
        }
    },
    methods: {
        nextImage() {
            if(this.startImage >= this.imageProxy.length) {
                this.startImage = 0;
            }else{
                this.startImage++
            }
        },
        prevImage() {
            if(this.startImage <= 0) {
                this.startImage = this.imageProxy.length - 1;
            }else{
                this.startImage--
            }
        },
        activateImage(imageIndex) {
            this.activeImage = imageIndex;
            //this.$store.dispatch('ItemInfo/set', {field: 'currentImage', imageIndex})
        },
        Images_onFileChanged (e) {
               var files = e.target.files || e.dataTransfer.files
                if (!files.length) {
                    return
                }
                this.createImage(files[0])
        },
        createImage(file) {
            var reader = new FileReader()
            var vm = this

            reader.onload = (e) => {
                console.log('length now: ' + this.imageArray.length)
                this.imageArray.push({id: this.imageArray.length + 1, large: e.target.result, thumb: e.target.result});
                this.source = this.imageArray;
                this.activateImage(this.imageArray.length);
            }
            reader.readAsDataURL(file)
        },
        removeImage: function (e) {
            this.userImage = ''
        },
        returnToPage(){
            this.isFocused = false;
        }
    },
    watch:{
        source(newsource, oldsource){
            console.log("do I get to change images?");
            this.uaIdx++;
        }
    }
};
</script>
